<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack('userForm')">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Create a Shift</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>Additional Information</h1>
            <p class="auth-subtext">Please enter details!</p>
          </div>
        </div>
        <div v-if="subscription">
          <SubscriptionBar :remainingSubscriptions="remainingSubscriptions" :totalSubscriptions="totalSubscriptions"
            text="Free shift remaining" v-if="totalSubscriptions > 0" />
          <div class="base">
            <!-- may be required in future.-->
            <!-- <div class="subscription-benefits" v-if="payNextDayEnabled === true">
              <div class="benefit-title">Transaction Fee</div>
              <div class="benefit-info">
                Without subscription: {{ transactionOriginalPrice }}% | With subscription:
                {{ transactionSubPrice }}%
              </div>
            </div> -->
            <div class="subscription-benefits">
              <div class="benefit-title">Booking Fee</div>
              <div class="benefit-info">{{ currencyFormat(bookingSubPrice) }}</div>
            </div>
          </div>
        </div>

        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')">
          <el-tabs v-model="activeName" stretch>
            <!-- <el-tab-pane label="Additional Shift Information (1) " name="additional"> -->
            <div class="travel-dropdown">
              <div class="travel-label">Travel payment:</div>
              <el-select popper-class="normal-select" class="covid-cert-select" style="width: 100%"
                v-model="formsData.userForm.paying_for_travel.value" placeholder="Select" @change="handleSelectChange">
                <el-option label="No travel payment" :value="0" />
                <el-option label="Full travel payment" :value="2" />
                <el-option label="Capped travel payment" :value="3" />
              </el-select>
            </div>
            <el-form-item prop="max_travel_amount" v-if="formsData.userForm.paying_for_travel.value == 3"
              class="price-input-outer price-input-outer--edit capped-amount">
              <div class="cap-label">Capped travel amount
                <el-tooltip :content="tooltipsMsg" placement="top" effect="customized">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>

              <div class="pr-flex">
                <!-- <div class="sign-price">$</div> -->
                <el-input ref="inputField" type="number" v-if="formsData.userForm.paying_for_travel.value == 3"
                  v-model="formsData.userForm.max_travel_amount.value" :placeholder="'Enter capped travel amount'"
                  :precision="2" :step="0.1" :min="0"
                  @change="checkFormValidation('userForm', false, 'maxTravelAmount')"
                  @blur="checkFormValidation('userForm', true, 'maxTravelAmount')" @keyup="formatTravelInput($event)"
                  @mouseenter="focusInputField()">
                  <template #prefix>$</template>
                </el-input>
              </div>

            </el-form-item>
            <el-form-item
              v-if="checkIsBulkShift === 1 && formsData.userForm.paying_for_travel.value !=0">
              <el-checkbox v-model="formsData.userForm.enable_travel_allowance_for_first_and_last_day.value"
                :true-label="1" :false-label="0">Will pay for travel first and last day<br>
                <small>If  first and last travel days are selected, the capped amount is split evenly.
                Example: A $100 cap is paid as $50 on the first day and $50 on the last day.</small>
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formsData.userForm.pay_for_flights.value" :true-label="1">Will pay for flights
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formsData.userForm.pay_for_accommodation.value" :true-label="1">Will pay for
                accomodation
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formsData.userForm.solo.value">Solo {{ $filters.systemLocumName(true, true) }}
                <br />
                <span>Will the {{ $filters.systemLocumName(true, false) }} be the only {{
                  $filters.systemLocumName(false, false) }} during this
                  shift?</span></el-checkbox>
            </el-form-item>
            <el-form-item v-if="isAustralia">
              <el-checkbox v-model="formsData.userForm.admin_aids.value">Dosage Administration Aids
              </el-checkbox>
            </el-form-item>
            <div class="flag__input-wrapper flag__input-wrapper--1">
              <el-form-item>
                <el-checkbox @change="onChangeTech" v-model="formsData.userForm.number_of_technicians.value">Number of
                  Technicians
                </el-checkbox>
              </el-form-item>
              <el-form-item prop="num_of_tech">
                <el-input-number class="el-input-number1" size="small" placeholder="0" :min="0" :max="50"
                  :disabled="!formsData.userForm.number_of_technicians.value"
                  v-model="formsData.userForm.num_of_tech.value"></el-input-number>

              </el-form-item>
            </div>
            <el-form-item>
              <el-checkbox v-model="formsData.userForm.open_up.value">Open Pharmacy
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formsData.userForm.close.value">Close Pharmacy
              </el-checkbox>
            </el-form-item>
            <!-- </el-tab-pane> -->
            <!-- <el-tab-pane label="Additional Shift Information (2) " name="other"> -->
            <!-- <div class="form_text">
                <div class="title">Immuniser Required?</div>
              </div> -->
            <!-- <el-form-item>
              <div class="select-label">Select Platform Role</div>
              <el-select popper-class="normal-select" class="custom-select" v-model="formsData.userForm.platform_role_id.value"
                placeholder="Platform Role" label="Platform Role Required">
                <el-option v-for="item in platformRoleOption" :key="item.id" :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item>
              <div class="select-label">{{ message.Immuniser }} Required?</div>
              <el-select popper-class="normal-select" class="custom-select"
                v-model="formsData.userForm.covid_cert_required.value" placeholder="Vaccination requirements"
                label="{{ message.Immuniser }} Required?">
                <el-option v-for="item in covidRequiredOption" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="label-select">
              <el-checkbox @change="onChangeLang" v-model="formsData.userForm.language_conditions.value">Language
                Preferences?
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <div class="select_wrapper" v-for="(select, i) in formsData.userForm.languages.selectValue" :key="i">
                <VueMultiselect v-model="formsData.userForm.languages.selectValue[i]" :options="
                      formsData.userForm.languages.options[i]
                        ? formsData.userForm.languages.options[i]
                        : []
                    " :searchable="true" :allow-empty="false" label="title" :placeholder="'Select language'"
                  track-by="title" :show-labels="false" :id="i" :custom-label="customLabel" @select="selectOptions"
                  :disabled="!formsData.userForm.language_conditions.value">
                  <template #singleLabel="props">
                    <span :class="'flag-icon flag-icon-' + props.option.flag"></span>
                    <span>{{ props.option.title }}</span>
                  </template>
                  <template #option="props" :class="props.option.show">
                    <span :class="'flag-icon flag-icon-' + props.option.flag"></span>
                    <span>{{ props.option.title }}</span>
                  </template>
                </VueMultiselect>
                <el-button type="transparent" circle @click="removeOption(i)"
                  :disabled="!formsData.userForm.languages.remove[i]">
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </el-form-item>
            <el-form-item class="label-select">
              <el-checkbox @change="onChangeParking" v-model="formsData.userForm.parking_check.value">Parking
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-input class="custom-input" placeholder="eg. Park at the back of the building"
                :disabled="!formsData.userForm.parking_check.value" v-model="formsData.userForm.parking.value"
                @change="checkFormValidation('userForm', false, 'parking')"
                @blur="checkFormValidation('userForm', true, 'parking')"
                @keyup="formsData.userForm.parking.value = $event.target.value"></el-input>
            </el-form-item>
            <el-form-item class="label-select">
              <el-checkbox @change="onChangeNotes" v-model="formsData.userForm.additional_notes.value">Additional
                Notes
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-input class="custom-input" :disabled="!formsData.userForm.additional_notes.value" type="textarea"
                :rows="7" placeholder="Enter your notes" v-model="formsData.userForm.notes.value">
              </el-input>
            </el-form-item>
            <!-- </el-tab-pane> -->
          </el-tabs>
        </el-form>

        <el-button class="primary w-full mt-auto" @click="goNext('userForm')" :disabled="formsData.userForm.disabled">
          Next
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject, ref, nextTick,computed,watch } from "vue";
import VueMultiselect from "vue-multiselect";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formValidate from "@/hooks/form/validate/validate";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";
import formHooks from "@/hooks/form/form";
import SubscriptionBar from "@/components/Subscription/SubscriptionBar.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    VueMultiselect,
    SubscriptionBar
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const showInputField = ref(false);
    const inputField = ref(null);
    const jobCreatePageData = $store.getters.getJobCreatePageData;
    console.log("🚀 ~ setup ~ jobCreatePageData:", jobCreatePageData.dates);
    const checkDatesContinuous = jobCreatePageData.dates;
    const checkIsBulkShift = jobCreatePageData.isBlockShift;
    const languages = ref([]);
    const languagesList = $store.getters.getLanguagesList;
    const userData = $store.getters.GET_USER_DATA;
    const isAustralia = isAustraliaRegion();
    const message = inject("messages");
    const payNextDayEnabled= ref(userData.payNextDayEnabled ? userData.payNextDayEnabled : false);

    const subscription = ref(userData.calculatedSubscriptions && userData.calculatedSubscriptions.subscription
                                ? userData.calculatedSubscriptions.subscription
                                : 0);
    const totalSubscriptions = ref(userData.calculatedSubscriptions && userData.calculatedSubscriptions.totalSubscriptions?userData.calculatedSubscriptions.totalSubscriptions:0);
    const remainingSubscriptions = ref(userData.calculatedSubscriptions && userData.calculatedSubscriptions.remainingSubscriptions? userData.calculatedSubscriptions.remainingSubscriptions :0);
    const transactionOriginalPrice = ref(userData.calculatedSubscriptions && userData.calculatedSubscriptions.transactionOriginalPrice? userData.calculatedSubscriptions.transactionOriginalPrice : 0);
    const transactionSubPrice = ref(userData.calculatedSubscriptions && userData.calculatedSubscriptions.transactionSubPrice? userData.calculatedSubscriptions.transactionSubPrice : 0);
    const bookingSubPrice = ref(userData.calculatedSubscriptions && userData.calculatedSubscriptions.bookingSubPrice?userData.calculatedSubscriptions.bookingSubPrice:0);
    

    const tooltipsMsg="Please enter maximum travel compensation limit for return trip. If a locums travel compensation is lower than the maximum amount, the app will adjust accordingly.";
    Object.keys(languagesList).forEach((key) => {
      const language = {
        title: languagesList[key],
        desc: key,
        flag: key.split("_")[1] ? key.split("_")[1].toLowerCase() : false,
        show: true,
        $isDisabled: key.split("_")[1] ? false : true,
      };

      languages.value.push(language);
    });


    const progressBarWidth = computed(() => {
      const percentage = (remainingSubscriptions.value / totalSubscriptions.value) * 100;
      return `${percentage}%`;
    });
 

    const barColor = computed(() => {
      // Define your desired bar color logic here
      return '#2463FF';
    });

    function focusInputField() {
      if (inputField.value) {
        inputField.value.$nextTick(() => {
          inputField.value.focus();
        });
      }
    }
    const formatTravelInput = (event)=> {
    // Restrict to 2 decimal places
    let value = event.target.value;
    if (value.includes('.')) {
      // Split by decimal point and keep only two decimals
      let parts = value.split('.');
      if (parts[1].length > 2) {
        parts[1] = parts[1].substring(0, 2);
      }
      event.target.value = parts.join('.');
    }
    // Update v-model
    formsData.userForm.max_travel_amount.value = parseFloat(event.target.value);
  }



    function handleSelectChange(value) {
      
      if (value === 3) {
        showInputField.value = true;
        nextTick(() => {
          inputField.value.focus();
        });

    formsDataArray.userForm.max_travel_amount.validators =  [
          {
            validator: (rule, formField, callback) => {
              formValidate.validate(
                rule,
                formField,
                "maxTravelAmount",
                callback,
                setFormValidation
              );
            },
          },
        ];
        // checkFormValidation("userForm", true);
     
      } else {
        if(formsDataArray.userForm.max_travel_amount){
          formsData.userForm.max_travel_amount.value =  null;
          delete formsDataArray.userForm.max_travel_amount.validators;
          checkFormValidation("userForm", true);
        }
        
      }
      formHooks(formsDataArray)
    }
    const formsDataArray = {
      userForm: {
        language_conditions: {
          value: jobCreatePageData.language_conditions
            ? jobCreatePageData.language_conditions
            : false,
        },
        languages: {
          value: jobCreatePageData.languages.length
            ? jobCreatePageData.languages
            : [null],
          selectValue: [null],
          options: [],
          remove: [false],
        },
        // platform_role_id: {
        //   value: jobCreatePageData.platform_role_id
        //     ? jobCreatePageData.platform_role_id
        //     : 1,
        // },
        covid_cert_required: {
          value: jobCreatePageData.covid_cert_required
            ? jobCreatePageData.covid_cert_required
            : 0,
        },
        solo: {
          value: jobCreatePageData.solo == 1 ? true : false,
        },
        paying_for_travel: {
          value: jobCreatePageData.paying_for_travel
            ? jobCreatePageData.paying_for_travel
            : 0,
        },
        max_travel_amount:{
          ref: {},
          value:jobCreatePageData.max_travel_amount
            ? jobCreatePageData.max_travel_amount
            : '',
          },
        round_trip: {
          value: jobCreatePageData.round_trip
          ? jobCreatePageData.round_trip 
          : 0,
        },
        enable_travel_allowance_for_first_and_last_day: {
          value: jobCreatePageData.enable_travel_allowance_for_first_and_last_day
            ? jobCreatePageData.enable_travel_allowance_for_first_and_last_day
            : 0,
        },
        pay_for_flights: {
          value: jobCreatePageData.pay_for_flights
            ? jobCreatePageData.pay_for_flights
            : 0,
        },
        pay_for_accommodation: {
          value: jobCreatePageData.pay_for_accomodation
            ? jobCreatePageData.pay_for_accomodation
            : 0,
        },
        number_of_technicians: {
          value: jobCreatePageData.number_of_technicians
            ? jobCreatePageData.number_of_technicians
            : false,
        },
        num_of_tech: {
          ref: {},
          valueTemp: "",
          value: jobCreatePageData.num_of_tech
            ? jobCreatePageData.num_of_tech
            : "",
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "numOfTech",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        additional_notes: {
          value: jobCreatePageData.additional_notes
            ? jobCreatePageData.additional_notes
            : false,
        },
        notes: {
          value: jobCreatePageData.notes ? jobCreatePageData.notes : null,
        },
        open_up: {
          value: jobCreatePageData.open_up ? jobCreatePageData.open_up : false,
        },
        close: {
          value: jobCreatePageData.close ? jobCreatePageData.close : false,
        },
        admin_aids: {
          value: jobCreatePageData.admin_aids == 1 ? true : false,
        },
        home_med_review: {
          value: jobCreatePageData.home_med_review == 1 ? true : false,
        },
        parking_check: {
          value: jobCreatePageData.parking_check
            ? jobCreatePageData.parking_check
            : false,
        },
        parking: {
          value: jobCreatePageData.parking ? jobCreatePageData.parking : null,
        },
      },
    };

    const customLabel = ({ title, desc }) => {
      return `${title} – ${desc}`;
    };

    const selectOptions = (selectedOption, id) => {
      setOption(selectedOption, id);

      formsData.userForm.languages.value[id] = selectedOption.desc;
      checkFormValidation("userForm", true);
    };

    const addEmptyOption = (id, remove) => {
      function addOption(id) {
        formsData.userForm.languages.selectValue.push(null);
        formsData.userForm.languages.options.push(null);
        formsData.userForm.languages.options[id] = languages.value.filter(
          (x) => x.show
        );
      }

      if (remove && languages.value.every((x) => x.show == false)) {
        addOption(id);
      } else if (!remove && languages.value.some((x) => x.show == true)) {
        addOption(id);
      }
    };

    const removeOption = (id) => {
      if (formsData.userForm.languages.selectValue.length > 1) {
        addEmptyOption(formsData.userForm.languages.options.length + 1, true);

        languages.value.some((x) => {
          if (formsData.userForm.languages.selectValue[id].desc == x.desc) {
            x.show = true;
            return true;
          }
        });
        formsData.userForm.languages.options.splice(id, 1);
        formsData.userForm.languages.selectValue.splice(id, 1);
        formsData.userForm.languages.value.splice(id, 1);
      } else {
        languages.value.some((x) => {
          if (formsData.userForm.languages.selectValue[id].desc == x.desc) {
            x.show = true;
            return true;
          }
        });
        formsData.userForm.languages.selectValue[id] = null;
      }
      setOptionsValue();
      checkFormValidation("userForm", true);
    };

    // Watch for changes in parking_check.value
    watch(() => formsData.userForm.parking_check.value, (newValue, oldValue) => {
      console.log('parking_check.value changed:', newValue, oldValue);
     
    });

    const setOption = (lang, id) => {
      if (lang.desc == "Remove") {
        console.log(id);
      } else if (id !== undefined) {
        languages.value.some((x) => {
          if (lang.desc == x.desc) {
            x.show = false;
            return true;
          }
        });

        if (formsData.userForm.languages.selectValue[id] != null) {
          languages.value.some((x) => {
            if (formsData.userForm.languages.selectValue[id].desc == x.desc) {
              x.show = true;
              return true;
            }
          });
        } else {
          addEmptyOption(id + 1);
        }

        languages.value.some((x) => {
          if (lang.desc == x.desc) {
            x.show = false;
            formsData.userForm.languages.selectValue[id] = lang;
            return true;
          }
        });

        formsData.userForm.languages.options[id] = languages.value.filter(
          (x) => x.show
        );

        if (formsData.userForm.languages.selectValue[id] != null) {
          formsData.userForm.languages.remove.push(true);
        }
      } else {
        lang.forEach((element, i) => {
          languages.value.some((x) => {
            if (element == x.desc) {
              x.show = false;
              if (formsData.userForm.languages.selectValue[i] !== undefined) {
                formsData.userForm.languages.selectValue[i] = x;
              } else {
                formsData.userForm.languages.selectValue.push(x);
              }
              return true;
            }
          });
          // formsData.userForm.languages.options[i] = languages.value.filter(x => x.show)
          formsData.userForm.languages.options[i] = languages.value.filter(
            (x) => x.show
          );
        });

        lang.forEach((element, i) => {
          formsData.userForm.languages.options[i] = languages.value.filter(
            (x) => x.show
          );
          if (formsData.userForm.languages.selectValue[id] != null) {
            formsData.userForm.languages.remove.push(true);
          }
        });

        if (formsData.userForm.languages.value[0] != null) {
          addEmptyOption(formsData.userForm.languages.options.length);
        }
      }

      setOptionsValue();
    };

    const setOptionsValue = () => {
      formsData.userForm.languages.options.forEach((option, i) => {
        formsData.userForm.languages.options[i] = languages.value.filter(
          (x) => x.show
        );
        if (formsData.userForm.languages.selectValue[i] != null) {
          formsData.userForm.languages.remove[i] = true;
        } else {
          formsData.userForm.languages.remove[i] = false;
        }
      });
    };

    const goBack = (formName) => {
      $store.dispatch("setJobCreatePageData", getFormValues(formName));
      $router.push({
        name: "job_create_rate",
      });
    };

      const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          const paysTravel = Number(formsData.userForm.paying_for_travel.value) !== 0;
          const isBulkShift = checkIsBulkShift === 1;
          if (!isBulkShift || !paysTravel) {
            formsData.userForm.enable_travel_allowance_for_first_and_last_day.value = 0;
          }
          $store.dispatch("setJobCreatePageData", getFormValues(formName));
          // $router.push({
          //   name: "shift_visibility",
          // });
          $router.push({
            name: "multiple_shift_visibility",
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
const platformRoleOption = ref([]);
    onMounted(async () => {
      setPageClassGlobal("global_job_create_page");
      setFormRefs();
      setOption(formsData.userForm.languages.value);
      
      try {
        let platformRoleResponse = await $store.dispatch("GET_PLATFORM_ROLE");
         platformRoleOption.value = platformRoleResponse.data;
      } catch (error) {
        console.error("Error fetching platform roles:", error);
      }

      // checkFormValidation("userForm");
    });

    const activeName = "additional";

    const onChangeLang = (e) => {
      if (e == false) {
        formsData.userForm.languages.selectValue = [null];
      }
    };
    const onChangeTech = (e) => {
      if (e == false) {
        formsData.userForm.num_of_tech.value = null;
      }
    };
    const onChangeNotes = (e) => {
      if (e == false) {
        formsData.userForm.notes.value = "";
      }
    };
    const onChangeParking = (e) => {
      if (e == false) {
        formsData.userForm.parking.value = "";
      }
      // if (e == false) {
      //   formsDataArray.userForm.parking.value = "";
      //   delete formsDataArray.userForm.parking.validators;
      //   checkFormValidation("userForm", true);
      // }else{
      //   formsDataArray.userForm.parking.validators =  [
      //     {
      //       validator: (rule, formField, callback) => {
      //         formValidate.validate(
      //           rule,
      //           formField,
      //           "parking",
      //           callback,
      //           setFormValidation
      //         );
      //       },
      //     },
      //   ];
      // }
      // formHooks(formsDataArray)
    };
    const currencyFormat = (value) => {
      return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(value);
    };
    const radioSelected = function() {
      formsData.userForm.round_trip.value = 0
    }
    const travelPaymentOptions = [
      {
        label: "No Travel",
        input: null,
        value: 0,
        description: "No travel compensation paid to locum for this job",
      },
      {
        label: "Pay Daily Round Trip",
        value: 1,
        input: {
          value: null,
        },
        description: ""
        // description:
        //   "Travel compensation paid to locum for this job for every Km travelled to each shift. Optional to add Max Distance to limit payable distance, if no value then every Km will have travel applied  ",
      },
      {
        label: "Pay first and last day travel",
        input: null,
        value: 2,
        description: ""
        // description: `Travel to be paid to locum on the first and last day of consecutive shifts where the distance is above 200km`,
      },
    ];
    const covidRequiredOption = [
      { label: "Not Required", value: 0 },
      { label: "Mandatory", value: 1 },
      { label: "Nice to have", value: 2 },
    ];

    // const platformRoleOption = [
    //   { label: "Pharmacist", value: 1 },
    //   { label: "Dispense Technician", value: 2 },
    // ];
    function areDatesContinuous(dates) {
      // Parse the dates into JavaScript Date objects and sort them in ascending order
      const parsedDates = dates
        .map(date => new Date(date.split("/").reverse().join("-"))) // Convert "dd/mm/yyyy" to "yyyy-mm-dd"
        .sort((a, b) => a - b);

      // Check if the difference between consecutive dates is 1 day
      for (let i = 0; i < parsedDates.length - 1; i++) {
        const diffInTime = parsedDates[i + 1] - parsedDates[i];
        const diffInDays = diffInTime / (1000 * 60 * 60 * 24); // Convert milliseconds to days
        if (diffInDays !== 1) {
          return false;
        }
      }

      return true;
    }

    // Check if the dates are continuous
    const areDatesValid = computed(() => areDatesContinuous(checkDatesContinuous));


    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      travelPaymentOptions,
      radioSelected,
      checkFormValidation,
      formsData,
      goBack,
      goNext,
      activeName,
      customLabel,
      selectOptions,
      removeOption,
      covidRequiredOption,
      platformRoleOption,
      onChangeLang,
      onChangeTech,
      onChangeNotes,
      onChangeParking,
      showInputField,
      handleSelectChange,
      focusInputField,
      inputField,
      tooltipsMsg,
      subscription,
      totalSubscriptions,
      remainingSubscriptions,
      progressBarWidth,
      barColor,
      transactionOriginalPrice,
      transactionSubPrice,
      bookingSubPrice,
      userData,
      currencyFormat,
      isAustralia,
      formatTravelInput,
      message,
      areDatesContinuous,
      checkDatesContinuous,
      areDatesValid,
      checkIsBulkShift,
      payNextDayEnabled
    };
  },
};
</script>
